import { CasestudiesItem } from '@/lib/api/types/basic';

export const isCaseStudiesType = (data?: CasestudiesItem | null): data is CasestudiesItem =>
  data !== undefined && data !== null && data.content?.component === 'caseStudies';
